import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Icon, IconButton } from 'investira.react.components';

/**
 * Renderiza o componente CloseIconButton.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {number} props.size - Tamanho aplicado ao componente ou ícone.
 * @param {string} props.color - Cor usada na renderização do componente.
 * @param {Function} props.onClick - Callback executado ao clicar no componente.
 * @param {boolean} props.disabled - Indica se o componente deve ser desabilitado.
 * @returns {JSX.Element} Elemento renderizado pelo componente.
 */
const CloseIconButton = memo(props => {
    const { onClick, size, color, disabled } = props;

    return (
        <IconButton onClick={onClick} disabled={disabled}>
            <Icon iconName="remove" size={size} color={disabled ? 'secondary' : color} />
        </IconButton>
    );
});

CloseIconButton.propTypes = {
    size: PropTypes.number,
    color: PropTypes.string,
    onClick: PropTypes.func
};

CloseIconButton.defaultProps = {
    size: 22,
    color: 'error'
};

export default CloseIconButton;
